import { createFileRoute } from '@tanstack/react-router';

import { PageShell } from '@/components/app/page-shell';
import { PrivacySettingsSection } from '@/features/privacy/privacy-settings-section';

export const Route = createFileRoute(
  '/_authed/dashboard/settings/consent-privacy'
)({ component: PrivacySettingsPage });

function PrivacySettingsPage() {
  return (
    <PageShell className="pt-10 pb-8" maxWidth="max-w-[960px]">
      <title>Privacy | Borrah</title>
      <h1 className="text-2xl font-semibold">Privacy</h1>
      <PrivacySettingsSection />
    </PageShell>
  );
}
